import { render, staticRenderFns } from "./ActividadLista.html?vue&type=template&id=481dbc75&external"
import script from "./ActividadLista.vue?vue&type=script&lang=js"
export * from "./ActividadLista.vue?vue&type=script&lang=js"
import style0 from "./ActividadLista.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports